import { gql } from '@apollo/client';

export const CUSTOMER_ORDERS = gql`
  query getCustomerOrders(
    $customerAccessToken: String!
    $limit: Int!
    $cursor: String
  ) {
    customerAccessToken @client @export(as: "customerAccessToken")
    customer(customerAccessToken: $customerAccessToken) {
      id
      orders(
        first: $limit
        after: $cursor
        sortKey: PROCESSED_AT
        reverse: true
      ) {
        edges {
          node {
            id
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export default {};
